<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content" v-html='content'>
                        
                    </div>
                </section>
            </el-main>
        </el-container>
    </el-container>

</template>
<script>
import commonheader from "../common/commonHeader.vue"; //头部组件
import leftMenu from "../common/leftMenu.vue"; //头部组件
import exit from "../common/exit.vue"; //头部组件
export default {
    name: 'studentsNote',
    components: {
        commonheader,
        leftMenu,
        exit
    },
    data(){
        return {
            content:'',
            loading:true
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";

        this.$store.dispatch('agreement', {}).then((res) => {
            if (res.code) {
                this.content = res.data.agreement;
            }
            this.loading = false;
        }).catch(error=>{
            console.error('错误信息：', error);
            this.loading = false;
        })
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    .title
        margin 25px 0 19px
        font-size 20px
        color #0173FF
        // border-left 2px solid #0173FF
        padding-left 10px
        background-image $menu_border
        background-repeat no-repeat
        background-size 4px 22px
        background-position  0 4px
    p
        font-size 16px
        color #333
        line-height 30px
</style>


// WEBPACK FOOTER //
// src/components/my/agreement.vue